import {DatapointType} from "@/models/response/BrainpowerApiResponse";

export interface Section {
  Title: string
}

export interface PlatformsSection extends Section {
  conversionByPlatformWeekday: ConversionByPlatformWeekday
}

export interface ConversionByPlatformWeekday extends Section {
  title: string
  header: Header
  data: [{ category: string, weekdays: WeekDays }]
}

export interface Header {
  insights: string
}

export interface WeekDays {
  mon: number
  tue: number
  wed: number
  thurs: number
  fri: number
  sat: number
  sun: number
}

export enum DisplayMode {
  FullRow, Centered
}

export interface DataTransform {
  omitZero?: boolean
  normalizeValuesBetweenZeroAndOne?: boolean
  threshold?: number
  showAverage?: boolean
  maxRows?: number
}

export interface DataItem {
  title?: string
  columnHeaders: string[]
  tooltip?: string
  data: ChartData[],
  prevData?: ChartData[]
  chartType: string[],
  chartName: string,
  periodStart?: Date,
  periodEnd?: Date
  chartOptions?: object
  chartPlugins?: Array<any>
  id?: string
  qcStatus?: string
  woWValuesIncluded?: boolean
  displayMode: DisplayMode,
  cssClasses?: string[]
  datapointType?: DatapointType,
  summaryIndex?:number;
}


export interface ChartData {
  labels?: string[]
  datasets?: DataSet[],
  datapointId?: string,
  title?: string,
  insight?: string,

}

export interface DataSet {
  label?: string
  data: any
  type?: string
  backgroundColor?: string | Array<any>
  xAxisID?: string
  yAxisID?: string
  pointRadius?: number;
  pointHoverRadius?: number;
  hidden?: boolean
}

export interface Downloadable {
  download: Function
}

export interface ImageParams {
  w: number;
  h: number;
  src: string;
}

export interface Rectangle {
  x: number;
  y: number;
  w: number;
  h: number;

}
